import * as yup from 'yup'

const schema = yup.object().shape({
  versionOption: yup
    .string()
    .oneOf(['current', 'new'], 'Selecione uma das opções')
    .required(),
})

export default schema
